const EMPTY = new Set(['', '-', '—', 'n/a', 'null', 'none', 'sin dato', 'sin datos', 'sin dirección', 'sin municipio']);
const clean = value => {
  const text = String(value ?? '').replace(/https?:\/\/\S+|www\.\S+/gi, '').replace(/\s+/g, ' ').trim();
  return EMPTY.has(text.toLocaleLowerCase('es-ES')) ? '' : text;
};
const words = value => clean(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es-ES').replace(/[^a-z0-9]+/g, ' ').trim();

export const shareLocation = asset => {
  let address = clean(asset?.direccion);
  const town = clean(asset?.municipio);
  if (!town || !address) return { address, town };
  const aliases = [town, ...town.split('/'), town.replace(/\([^)]*\)/g, '').trim()].map(words).filter(Boolean);
  const cityTail = tail => {
    const match = clean(tail).match(/^(?:(\d{5})[\s,]+)?(.+)$/);
    return match && aliases.includes(words(match[2])) ? { postal: match[1] || '' } : null;
  };
  // Sólo separar un municipio final inequívoco; nunca mutilar nombres de calles.
  const parenthesis = address.match(/^(.*?)\s*\(([^()]*)\)\s*$/);
  const separated = address.match(/^(.*)(?:,\s*|;\s*|\s+[-–—·]\s+)([^,;]+)$/);
  const postal = address.match(/^(.*?)\s+(\d{5})\s+(.+)$/);
  let extracted = false;
  if (parenthesis && cityTail(parenthesis[2])) {
    const suffix = cityTail(parenthesis[2]).postal;
    address = parenthesis[1].trim() + (suffix ? ` (${suffix})` : ''); extracted = true;
  } else if (separated && cityTail(separated[2])) {
    const suffix = cityTail(separated[2]).postal;
    address = separated[1].trim() + (suffix ? `, ${suffix}` : ''); extracted = true;
  } else if (postal && aliases.includes(words(postal[3]))) {
    address = `${postal[1].trim()} ${postal[2]}`; extracted = true;
  } else if (cityTail(address)) {
    address = cityTail(address).postal; extracted = true;
  }
  const alreadyPresent = !extracted && aliases.some(alias => ` ${words(address)} `.includes(` ${alias} `));
  return { address: address.trim().replace(/[,;·]\s*$/, '').trim(), town: alreadyPresent ? '' : town };
};

export const assetShareMessage = (asset, url) => {
  const reference = clean(asset?.codigo_npl);
  const { address, town } = shareLocation(asset);
  const location = [address && `📍 ${address}`, town && `🏙️ ${town}`].filter(Boolean).join(' · ');
  return [reference && `🏠 ${reference}`, location, `🔗 ${url}`].filter(Boolean).join('\n');
};